import React, { useEffect, useState, useRef } from "react";
import Culturet from "../../../assests/images/BG (2).png";
import Vishal from "../../../assests/devloper/Vishal.jpg";
import Aniket from "../../../assests/devloper/Aniket_Gujrathi.jpg";
import Nikita from "../../../assests/devloper/Nikita.png";
import Nikunj from "../../../assests/devloper/Nikunj.jpeg";
import Pooja from "../../../assests/devloper/POOJA_Pandya.jpeg";
import Pankaj from "../../../assests/devloper/unnamed.jpg";
import Pranchil from "../../../assests/devloper/Pranchil.png";
import Prabhijit from "../../../assests/devloper/Pranvir.jpeg";
import Pranvir from "../../../assests/devloper/Pranvir.jpg";
import Shehnila from "../../../assests/devloper/Shehnila.jpg";
import Sonalika from "../../../assests/devloper/Sonalika_Sharma.jpg";
import Subhangi from "../../../assests/devloper/Subhangi.jpg";
import Anish from "../../../assests/devloper/anis.jpg";
import Sneha from "../../../assests/devloper/Sneha_Gupta.jpeg";
import Akansksha from "../../../assests/devloper/Akansksha Sharma.jpeg";
import Lokendra from "../../../assests/devloper/Lokendra (2).jpeg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";

// const testimonials = [
//   {
//     photo: Vishal,
//     name: "Vishal Vishwakarma",
//     description:
//       "Working at TekIT Softwares has been an incredible experience! The work environment is dynamic, collaborative, and fosters continuous learning.",
//   },
//   {
//     photo: Aniket,
//     name: "Aniket Gujrathi",
//     description:
//       "I completed four incredible years at TekIT Family, I take a moment to reflect on this rewarding journey. It has been an enriching experience filled with learning, growth, and invaluable collaborations.",
//   },
//   {
//     photo: Shehnila,
//     name: "Shehnila Rizvi",
//     description:
//       "Working at TekIT for the past three years has been a rewarding and fulfilling experience. I am proud to be part of an organization that values innovation, teamwork, and employee development. The work culture here fosters creativity, learning, and professional growth, making it an ideal place to thrive. I appreciate the support and trust the company has shown in me, and I look forward to contributing even more in the years ahead!",
//   },
//   {
//     photo: Nikita,
//     name: "Nikita Yadav",
//     description:
//       "The unwavering trust and support from my leaders at TekIT have shaped my professional journey, inspiring me to embrace challenges and deliver my best with confidence.",
//   },
//   {
//     photo: Pranchil,
//     name: "Pranchil Shukla",
//     description:
//       "At TekIT, I’m empowered to think boldly, challenge boundaries, and make a real impact — driving both my growth and the team’s success.",
//   },
//   {
//     photo: Pooja,
//     name: "Pooja Pandey",
//     description:
//       "Reflecting on my incredible journey of almost 2.4 years at TekIT, I am filled with gratitude and appreciation of management . TekIT has truly been a place that values work-life balance, fosters teamwork, and supports personal and professional growth. The management's unwavering support and encouragement have played a significant role in every milestone I’ve achieved. ",
//   },
//   {
//     photo: Nikunj,
//     name: "Nikunj",
//     description:
//       "Working at TekIT has been a rewarding experience. The leadership trust, team spirit, and opportunities to grow make it a great place to thrive and contribute meaningfully.",
//   },
//   {
//     photo: Pankaj,
//     name: "Pankaj",
//     description:
//       "I truly appreciate TekIT’s inclusive and competitive work culture. It’s inspiring to be part of a company that not only values diverse perspectives but also fosters growth and excellence. At TekIT, we are empowered to bring our authentic selves to work while thriving in a dynamic and driven environment."
//     ,
//   },
//   {
//     photo: Prabhijit,
//     name: "Prabhijit",
//     description:
//       "I've really enjoyed my time at TekIT. I like how everyone works together, and it's a friendly place where you always feel like you can ask for help. I've also had the opportunity to learn a lot and grow professionally since joining the team.",
//   },
//   {
//     photo: Sonalika,
//     name: "Sonalika",
//     description:
//       "Working at TekIT has been a rewarding experience. The environment fosters both professional and personal growth, and the support from my colleagues has truly empowered me to excel in my role.",
//   },
//   {
//     photo: Subhangi,
//     name: "Subhangi",
//     description:
//       "Working at TekIT for the past 6 months has been a rewarding experience. The company provides a great work environment, fosters professional growth, and values employee contributions. I appreciate the supportive team and leadership that encourages continuous learning and career development",
//   },
//   {
//     photo: Anish,
//     name: "Anish Gupta",
//     description:
//       "I’ve been with TekIT Software Solutions for over three years, and it’s been a truly rewarding experience. The company offers a great work culture, supportive leadership, and constant opportunities to grow. I’m proud to be part of a team that values innovation, collaboration, and its people. Excited for what’s ahead!s",
//   },
//   {
//     photo: Pranvir,
//     name: "Pranvir",
//     description:
//       "My experience at TekIT was truly rewarding, providing me with opportunities to work on cutting-edge technologies and collaborate with a talented team. The innovative environment and challenging projects helped me grow both technically and professionally.",
//   },
//   {
//     photo: Akansksha,
//     name: "Akansha Sharma",
//     description:
//       "Being part of TekIT means working with some of the best minds in software engineering, IT staffing, and cloud solutions. The company supports professional growth and fosters a collaborative work environment.",
//   },
//   {
//     photo: Lokendra,
//     name: "Lokendra",
//     description:
//       "Being part of TekIT Solutions Pvt. Ltd. has been an enriching experience. The supportive team, excellent work culture, and ample growth opportunities make it a fantastic place to work. I’m grateful for the opportunity to contribute to meaningful projects while continuously learning and growing.",
//   },
//   {
//     photo: Sneha,
//     name: "Sneha Gupta",
//     description:
//       "What I love most about TekIT is the culture—it’s welcoming, supportive, and genuinely inclusive. Being part of a team that values individuality and encourages you to grow as your true self makes all the difference.”",
//   },
// ];

const testimonials = [
  {
    photo: Vishal,
    name: "Vishal Vishwakarma",
    description:
      "Working at TekIT Softwares has been an incredible experience! The work environment is dynamic, collaborative, and fosters continuous learning.",
  },
  {
    photo: Aniket,
    name: "Aniket Gujrathi",
    description:
      "I completed four incredible years at TekIT Family, I take a moment to reflect on this rewarding journey. It has been an enriching experience filled with learning, growth, and invaluable collaborations.",
  },
  {
    photo: Shehnila,
    name: "Shehnila Rizvi",
    description:
      "Three rewarding years at TekIT, where innovation, teamwork, and growth are at the core. Grateful for the support and excited to contribute even more in the future!",
  },
  {
    photo: Nikita,
    name: "Nikita Yadav",
    description:
      "The unwavering trust and support from my leaders at TekIT have shaped my professional journey, inspiring me to embrace challenges and deliver my best with confidence.",
  },
  {
    photo: Pranchil,
    name: "Pranchil Shukla",
    description:
      "At TekIT, I’m empowered to think boldly, challenge boundaries, and make a real impact — driving both my growth and the team’s success.",
  },
  {
    photo: Pooja,
    name: "Pooja Pandey",
    description:
      "Reflecting on 2.4 amazing years at TekIT, I'm grateful for the supportive management, strong teamwork, and a culture that truly values growth and work-life balance.",
  },
  {
    photo: Nikunj,
    name: "Nikunj",
    description:
      "Working at TekIT has been a rewarding experience. The leadership trust, team spirit, and opportunities to grow make it a great place to thrive and contribute meaningfully.",
  },
  {
    photo: Pankaj,
    name: "Pankaj",
    description:
      "I appreciate TekIT’s inclusive, growth-focused culture. It’s empowering to work in a place that values diversity, excellence, and authenticity.",
  },
  {
    photo: Prabhijit,
    name: "Prabhijit",
    description:
      "I've truly enjoyed my time at TekIT — a friendly, collaborative environment where learning and growth are always encouraged.",
  },
  {
    photo: Sonalika,
    name: "Sonalika",
    description:
      "Working at TekIT has been a rewarding experience. The environment fosters both professional and personal growth, and the support from my colleagues has truly empowered me to excel in my role.",
  },
  {
    photo: Subhangi,
    name: "Subhangi",
    description:
      "The past 6 months at TekIT have been rewarding — a supportive team, growth-focused culture, and leadership that values learning and development.",
  },
  {
    photo: Anish,
    name: "Anish Gupta",
    description:
      "Over 3 years at TekIT Software Solutions have been truly rewarding — with a great culture, supportive leadership, and endless growth opportunities. Proud to be part of a team that values innovation and collaboration!",
  },
  {
    photo: Pranvir,
    name: "Pranvir",
    description:
      "My time at TekIT was rewarding — filled with learning, innovation, and collaboration on cutting-edge projects that boosted my technical and professional growth.",
  },
  {
    photo: Akansksha,
    name: "Akansha Sharma",
    description:
      "Being at TekIT means growing with brilliant minds in software, IT staffing, and cloud — all in a collaborative, growth-focused environment.",
  },
  {
    photo: Lokendra,
    name: "Lokendra",
    description:
      "Being at TekIT Solutions Pvt. Ltd. has been truly enriching — great culture, supportive team, and constant growth. Grateful to work on meaningful projects while learning every day.",
  },
  {
    photo: Sneha,
    name: "Sneha Gupta",
    description:
      "What I love most about TekIT is the culture—it’s welcoming, supportive, and genuinely inclusive. Being part of a team that values individuality and encourages you to grow as your true self makes all the difference.”",
  },
];

const Our_Team = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [bgPositionY, setBgPositionY] = useState(5.69531);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const { isIntersecting, boundingClientRect } = entry;
        const isEnteringFromBottom =
          isIntersecting && boundingClientRect.top > 0;

        setIsVisible(isEnteringFromBottom);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // whether animation should happen only once
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newPositionY = 5.69531 - scrollY * 3;
      setBgPositionY(newPositionY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [index, setIndex] = useState(0);
  const itemsPerPage = 3;
  const totalPages = Math.ceil(testimonials.length / itemsPerPage);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % totalPages);
    }, 4000);
    return () => clearInterval(interval);
  }, [totalPages]);

  const currentTestimonials = testimonials.slice(
    index * itemsPerPage,
    index * itemsPerPage + itemsPerPage
  );

  return (
    <>
    <Helmet>
        <title>Our Team | TekIT Software Solutions</title>
        <meta name="description" content="Meet the talented individuals who make up our team at TekIT Software Solutions. Discover their stories, expertise, and passion for innovation." />
        <link rel="canonical" href="https://www.tekitsolution.com/our-team" />
      </Helmet>
    <div className="z-1 ">
      <section
        ref={sectionRef}
        className={`relative lg:h-[470px] 2xl:h-[610px] overflow-hidden h-[800px]  duration-700 hidden lg:block font-recoleta`}
        // style={{
        //   backgroundImage: `url(${Culturet})`,
        // backgroundPosition: `0px ${bgPositionY}px`,
        // backgroundSize: "cover",
        // backgroundRepeat: "no-repeat",
        // backgroundAttachment: "fixed",
        //   opacity: 1,
        // }}
      >
        <img
          src={Culturet}
          alt="Join TekIT - Work with a passionate and skilled tech team"
          className="mt-14 w-full"
        />
        <div className="absolute lg:h-screen h-44 inset-0  z-0 transition-opacity duration-700"></div>

        <div className="container mx-auto h-full flex items-center justify-center text-center relative z-1">
          <div className="text-white">
            {/* <h1 className="text-[50px]" data-aos="fade-up">Happy team = Happy client</h1> */}
            <p data-aos="fade-up" className="text-[28px] opacity-60">
              A positive, creative, and vibing squad is key for taking the
              company to the next level.
            </p>
          </div>
        </div>
      </section>
      <section
        ref={sectionRef}
        className="relative overflow-hidden w-full h-[560px] block lg:hidden duration-700"
        // style={{
        //   backgroundImage: "url('https://apoorvaclinic.com/Backup_old_website/images/culturet.jpg')",
        //   backgroundSize: 'cover',
        //   backgroundPosition: 'center',
        // }}
      >
        <img
          src={Culturet}
          alt="Join TekIT - Work with a passionate and skilled tech team"
          className="mt-24 h-full w-full"
        />

        <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>

        <div className="relative z-1 flex flex-col items-center justify-center text-center h-full px-4">
          <div className="text-white">
            {/* <h1 className="lg:text-[35px] text-[64px] font-semibold mb-2" data-aos="fade-up">Happy team = Happy client</h1> */}
            <p className="lg:text-[16px] text-[40px] opacity-80">
              A positive, creative, and vibing squad is key for taking the
              company to the next level.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row px-6 lg:px-10">
          <div className="border-l-4 border-[#F86F4B] mr-6 h-32 hidden lg:block"></div>

          <div className="space-y-6 font-recoleta">
            <h2
              data-aos="fade-up"
              className="text-[48px] lg:text-[32px] 2xl:text-[40px] font-extrabold text-[#09588D]"
            >
              Collaboration drives success
            </h2>

            <p
              data-aos="fade-up"
              className="text-gray-800 leading-relaxed text-[32px] lg:text-[20px] 2xl:text-[26px] font-recoleta"
            >
              As a leading web design and development company, our energetic
              team delivers reliable services and empowers clients to achieve
              their goals. Our diverse, innovative team turns ideas into
              reality, ensuring timely delivery and satisfactory results. We
              focus on impactful business outcomes and comprehensive IT services
              to drive long-term productivity and profitability.
            </p>
          </div>
        </div>
      </section>

      {/* <div className="w-full max-w-7xl mx-auto px-4 py-12 font-recoleta">
                <h2 className="text-[36px] font-bold text-center mb-10">Employee Testimonials</h2>
                <div className="flex justify-center gap-8 flex-wrap">
                    {currentTestimonials.map((t, i) => (
                        <div
                            key={i}
                            className="w-96 h-96 bg-gradient-to-r from-[#0aace7] to-[#8fe1ff] rounded-full shadow-2xl flex flex-col items-center justify-center text-center px-6 py-4 transition-all duration-500"
                        >
                            <img
                                src={t.photo}
                                alt={t.name}
                                className="w-40 h-40 rounded-full object-cover  shadow mb-4"
                            />
                            <h3 className="font-semibold text-lg text-white">{t.name}</h3>
                            <p className="text-sm mt-2 text-white">{t.description}</p>
                        </div>
                    ))}
                </div>
            </div> */}
      <div
        className="w-[82%] lg:w-[82%] 2xl:w-full lg:max-w-7xl 2xl:max-w-7xl mx-auto px-4 py-12 "
        data-aos="fade-left"
      >
        <h2
          className="text-[48px] lg:text-[32px] 2xl:text-[40px] font-bold text-center mb-10 font-recoleta"
          data-aos="fade-up"
        >
          At TekIT, We’re Not Just Working — We’re Building Team
        </h2>

        <Swiper
          modules={[Autoplay]}
          slidesPerView={3}
          spaceBetween={30}
          loop={true}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          className="flex justify-center"
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 1 },
            1024: { slidesPerView: 3 },
          }}
        >
          {testimonials.map((t, i) => (
            <SwiperSlide key={i}>
              <div className="bg-gradient-to-r from-[#0aace7] to-[#8fe1ff] rounded-[200px]  flex flex-col items-center justify-start text-center px-6 py-6 w-[370px] h-[370px] mx-auto">
                <div className="relative group">
                  <img
                    src={t.photo}
                    alt={t.name}
                    className="w-28 h-28 rounded-full object-cover border-4 border-white shadow mb-4 transition-transform duration-300 group-hover:scale-150 z-1"
                  />
                </div>

                <h3 className="font-semibold text-[22px]  2xl:text-[26px]  lg:text-[20px] font-recoleta leading-tight">
                  {t.name}
                </h3>

                <div className="relative group mt-2 max-w-[280px]">
                  <p className="text-[18px] lg:text-[16px] 2xl:text-[20px] text-gray-700 font-recoleta mt-2 leading-relaxed cursor-pointer">
                    {t.description.length > 90
                      ? `${t.description.slice(0, 90)}...`
                      : t.description}
                  </p>
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 hidden group-hover:flex bg-[#09588D] leading-tight text-white text-sm border border-gray-300 p-4 w-[400px] shadow-lg z-1 -mb-[140px] rounded-xl">
                    {t.description}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
          
        </Swiper>
      </div>
    </div></>
  );
};

export default Our_Team;
